<template>
  <b-navbar id="global-navbar" class="global-navbar scrolled" toggleable="lg" fixed="top">
    <!-- :class="{ scrolled: scrolled, 'global-navbar-opened': collapseShown }" -->
    <div class="container">
      <span class="navbar-brand">
        <router-link :to="{ name: 'home' }"
          ><img
            src="../assets/images/logo/logo-taipei-city.svg"
            class="navbar-brand-logo-image"
            alt="臺北市政府-收據雲平台"
          />
        </router-link>
      </span>

      <b-navbar-toggle
        target="global-nav-collapse"
        v-if="
          this.$store.state.login.userName !== null &&
          this.$store.state.login.userName !== undefined
        "
      >
        <span class="nav-icon nav-icon-circle">
          <i class="far fa-user fa-fw icon icon-circle"></i>
        </span>
        <span class="nav-text">{{ this.$store.state.login.userName }} 先生/小姐，您好</span>
      </b-navbar-toggle>
      <!--  id="global-nav-collapse" -->
      <b-collapse
        is-nav
        appear
        id="global-nav-collapse"
        @show="onCollapseToggle(true)"
        @hide="onCollapseToggle(false)"
        style="margin-top: 0rem"
      >
        <div class="navbar-collapse-inner ml-auto">
          <!-- <ul class="navbar-nav align-items-lg-center">
            <li class="nav-item d-none d-lg-inline-block">
              <span class="nav-icon">
                <i class="far fa-user fa-fw icon icon-circle"></i>
              </span>
              <span class="nav-text"></span>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                style="margin-left: 90px; cursor: pointer"
                @click.prevent="platformLogin"
                >登入</a
              >
            </li>
          </ul>-->
          <ul
            class="navbar-nav align-items-lg-center"
            v-if="
              this.$store.state.login.userName !== null &&
              this.$store.state.login.userName !== undefined
            "
          >
            <li class="nav-item d-none d-lg-inline-block">
              <span class="nav-icon nav-icon-circle">
                <i class="far fa-user fa-fw icon icon-circle"></i>
              </span>
              <span class="nav-text">{{ this.$store.state.login.userName }} 先生/小姐，您好</span>
            </li>
            <li class="nav-item" style="text-align: right; cursor: pointer">
              <a class="nav-link" @click.prevent="signOutTPss">登出</a>
            </li>
          </ul>
        </div>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
import { mapMutations } from 'vuex';
// 共用方法
import UserMixin from '@/mixins/user';

export default {
  name: 'GlobalNavigation',

  mixins: [UserMixin],

  data() {
    return {
      scrolled: false,
      collapseShown: false,
      isLogin: false, // 是否登入
      getCookieRunVal: '',
    };
  },

  methods: {
    ...mapMutations('login', ['changeLogin']),

    signOutTPss() {
      this.$nextTick(() => {
        console.log('signOutTPss');
        this.axios({
          url: '/GovEReceipt/UserLoginService/LoginOut',
          method: 'post',
          data: {},
        })
          .then((res) => {
            console.log(res);
            if (res.data.object === true) {
              this.$userLogin();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },

    // signOutTPss() {
    //   this.getCookieRunVal = this.$getUUID('sessionId');
    //   const backTPEPass = process.env.VUE_APP_GOTPASS;
    //   console.log('backTPE', backTPEPass);

    //   const stateUserData = {
    //     isLogin: false,
    //     chanExpireDate: '',
    //     realName: '',
    //     userName: null,
    //   };
    //   this.changeLogin(stateUserData);
    //   this.$nextTick(() => {
    //     this.axios({
    //       url: '/GovEReceipt/CacheManagerService/Delete',
    //       method: 'post',
    //       data: {
    //         sessionId: this.getCookieRunVal,
    //       },
    //     })
    //       .then((res) => {
    //         console.log(res);
    //         if (res.data.object === true) {
    //           console.log('我要清除cookie');
    //           // document.cookie = 'sessionId=;expires=;';
    //           this.$clearCookie('sessionId', this.getCookieRunVal);
    //         }
    //         window.location.href = backTPEPass;
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //       });
    //   });
    // },
    onScrollHandler() {
      this.scrolled =
        window.pageYOffset >= (window.innerWidth >= 576 ? 71 : window.innerWidth * 0.4);
    },

    onCollapseToggle(nextStatus) {
      this.collapseShown = nextStatus;
    },
  },

  mounted() {
    window.addEventListener('scroll', this.onScrollHandler);
    console.log('this.$store.state.login.isLogin:', this.$store.state.login.isLogin);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScrollHandler);
  },
};
</script>
